export default "__VITE_ASSET__BdFrbK9L__"